import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedHTMLMessage } from "react-intl";
import Dialog from "components/dialog";
import { SimpleButton } from "components/buttons";
import { InsertUrlsTable, LarixUrlsTable, WebAnnouncer } from "./partial";
import { injectIntl } from "react-intl";
import { useImperativeTracking } from "components/tracking";
import Tabs, { Tab } from "components/tabs";
import { androidAppLarix, iOSAppLarix } from "config/paths";
import { webAnnouncerEnabled } from "config/features";

const InsertDialog = ({ className, buttonClassName, isCamera, event, intl, ...props }) => {
  const [open, setOpen] = useState(false);
  const track = useImperativeTracking();

  const handleOpenDialog = useCallback(
    e => {
      e.stopPropagation();
      track("opens dialog for inserting the " + (isCamera ? "external camera" : "announcer audio") + " into mixer");
      setOpen(true);
    },
    [isCamera, track],
  );

  const handleCloseDialog = useCallback(
    e => {
      e.stopPropagation();
      track("opens dialog for inserting the " + (isCamera ? "external camera" : "announcer audio") + " into mixer");
      setOpen(false);
    },
    [isCamera, track],
  );

  return (
    <>
      <SimpleButton
        onClick={handleOpenDialog}
        icon={isCamera ? "video-call" : "mic"}
        label={intl.formatMessage({ id: isCamera ? "event.insertCamera" : "event.insertAudio" })}
        rel="noopener noreferrer"
        variant="outlined"
        className={buttonClassName}
      />
      <Dialog
        className={className}
        open={open}
        onAccept={handleCloseDialog}
        title={intl.formatMessage(
          { id: isCamera ? "app.page.event.insertCamera.title" : "app.page.event.insertAudio.title" },
          { eventTitle: event.title },
        )}
      >
        <Tabs>
          <Tab label={intl.formatMessage({ id: "event.dialog.RTMP" })}>
            <FormattedHTMLMessage
              id={isCamera ? "app.page.event.insertCamera.description" : "app.page.event.insertAudio.description"}
            />
            <InsertUrlsTable event={event} isCamera={isCamera} />
          </Tab>
          <Tab label={intl.formatMessage({ id: "event.dialog.tool.Larix" })}>
            <FormattedHTMLMessage
              id="event.dialog.tool.Larix.description"
              values={{ larixAndroid: androidAppLarix, larixIOS: iOSAppLarix }}
            />
            <LarixUrlsTable event={event} isCamera={isCamera} />
          </Tab>
          {webAnnouncerEnabled && (
            <Tab label={intl.formatMessage({ id: "event.dialog.webAnnouncer" })}>
              <WebAnnouncer event={event} />
            </Tab>
          )}
        </Tabs>
      </Dialog>
    </>
  );
};

InsertDialog.propTypes = {
  /**
   * Indica si es cámara o audio
   */
  isCamera: PropTypes.bool,
  /**
   * Clase adicional del diálogo.
   */
  className: PropTypes.string,
  /**
   * Clase adicional del botón.
   */
  buttonClassName: PropTypes.string,
  /**
   * Evento
   */
  event: PropTypes.object,
};

export default injectIntl(InsertDialog);
